import { InputTextAccordionProps } from "./types"
import React from "react"
import styled from '~/ui/styled'
import { Text as TextCore } from "~widgets/text"
import { ButtonSolid } from "~components/button"

const ButtonWrapper = styled.View`
  flex-direction: row;
`
const Wrap = styled.View`
  flex-direction: column;
  align-self: flex-start;
  background-color: #fff;
  align-items: flex-start;
  padding: 7px ${({ theme }) => theme.space.md};
  margin-bottom: 1px;
  width: 100%;
`
const InputWrap = styled.View`
  width: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`
const Input = styled.TextInput`
  padding: 0px 0px;
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.text};
`
const Text = styled(TextCore)`
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.infoText};
  margin-bottom: 10px;
`
const SingleInputTextAccordion: React.FC<InputTextAccordionProps> = ({
  accordionProps,
  inputTextProps,
  buttonTextProps,
  buttonCoreProps,
  FunctionButton,
}) => {
  return (
    <Wrap {...accordionProps}>
      <Text>{accordionProps?.label}</Text>
      {/* <Input editable={inputTextProps?.editable} placeholder={inputTextProps?.placeholder}></Input> */}
      {buttonTextProps != null ? (
        <ButtonWrapper>
          <Input
            {...inputTextProps}
            style={{ flex: 1 }}
            editable={inputTextProps?.editable}
            placeholder={inputTextProps?.placeholder}
          ></Input>
          <ButtonSolid
            {...buttonCoreProps}
            text={buttonTextProps.text}
            // loading={loading}
            // disabled={formErr || !isAgreePrivacy}
            // onClick={onLogin}
          />
        </ButtonWrapper>
      ) : (
        <InputWrap>
          <Input {...inputTextProps} style={{ flex: 1 }}></Input>
          {FunctionButton && <FunctionButton />}
        </InputWrap>
      )}
    </Wrap>
  )
}
export default SingleInputTextAccordion
